import { render, staticRenderFns } from "./SuperomaticSelecter.vue?vue&type=template&id=01f9d94b&scoped=true&"
import script from "./SuperomaticSelecter.vue?vue&type=script&lang=js&"
export * from "./SuperomaticSelecter.vue?vue&type=script&lang=js&"
import style0 from "./SuperomaticSelecter.vue?vue&type=style&index=0&id=01f9d94b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01f9d94b",
  null
  
)

export default component.exports